// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.justify-left[data-v-22ba47ca]\n{\n\t-webkit-box-pack: left !important;\n\t    -ms-flex-pack: left !important;\n\t        justify-content: left !important;\n}\n.card-content-height[data-v-22ba47ca]\n{\n\theight: 120px;\n}\n", ""]);
// Exports
module.exports = exports;
